import { createFileRoute } from '@tanstack/react-router'
import { MarketingPage } from '../components/MarketingPage.js'

export const Route = createFileRoute('/about')({
  component: AboutPage,
})

function AboutPage() {
  return (
    <MarketingPage eyebrow="About us" title="Software built for the way Indian coaching academies actually run.">
      <p>
        Brightstars is a software platform for coaching academies across India.
        We help academy owners stop juggling spreadsheets, WhatsApp groups, and
        paper registers, and instead run fees, attendance, tests, and parent
        communication from one place.
      </p>

      <h2>What we offer</h2>
      <p>
        Brightstars is a subscription-based SaaS product. Academies sign up,
        choose a monthly or annual plan, and get access to:
      </p>
      <ul>
        <li>
          Online fee collection with UPI, card, and netbanking payments,
          powered by Razorpay.
        </li>
        <li>Daily attendance with automatic WhatsApp alerts to parents.</li>
        <li>Test marks and exam-board tracking visible to parents and teachers.</li>
        <li>
          A free parent portal. One account works across siblings and
          academies.
        </li>
        <li>
          WhatsApp and email broadcasts with templates, audit logs, and
          delivery receipts.
        </li>
        <li>
          White-labelled branding and custom domains on higher-tier plans.
        </li>
      </ul>

      <h2>Who we serve</h2>
      <p>
        We are built specifically for coaching academies: tuition centres, JEE
        and NEET coaching institutes, music and dance schools, sports
        academies, and exam-prep batches. Our pricing, channels, and templates
        are tuned for Indian operations: rupees in paise, WhatsApp-first
        parent communication, and Razorpay payments.
      </p>

      <h2>How we make money</h2>
      <p>
        Brightstars charges academies a monthly or annual subscription fee
        based on the plan they pick. Parents never pay us. They pay their
        academy through Razorpay, and the money is settled directly to the
        academy&apos;s bank account. Pricing, including applicable GST, is
        shown on our <a href="/#pricing">pricing page</a> before checkout.
      </p>

      <h2>Get in touch</h2>
      <p>
        Want a walkthrough, have a question about a feature, or interested in
        an enterprise plan? Email us at{' '}
        <a href="mailto:hello@brightstars.in">hello@brightstars.in</a> or visit
        our <a href="/contact">contact page</a>.
      </p>
    </MarketingPage>
  )
}
